import { render, staticRenderFns } from "./TherapyErrors.vue?vue&type=template&id=733b4269&scoped=true"
import script from "./TherapyErrors.vue?vue&type=script&lang=js"
export * from "./TherapyErrors.vue?vue&type=script&lang=js"
import style0 from "./TherapyErrors.vue?vue&type=style&index=0&id=733b4269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b4269",
  null
  
)

export default component.exports